import Card from "componentes/Card/Card";
import style from "./ProcuraSe.module.scss";


const ProcuraSe = () => {
  
  return (
    <section className={style.container}>
      <h1 className={style.titulo}>Animais desaparecidos em Uberaba - MG</h1>
      
      <main className={style.cards}>
        <Card />
      </main>
      
    </section>
  )
}

export default ProcuraSe;